import React, { useState, useMemo, useEffect } from 'react';
import { Table } from '../../components';
import './mleMakerChecker.scss';
import { toast } from 'react-toastify';
import {
  ERROR_MESSAGES,
} from '../../utils/constants/toastMessages';
import {
  API_VIEW_KYC_DOCUMENT,
} from '../../utils/API/apiUrls';
import { POST } from '../../utils/fetchWrappers';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';
import ImageViewModal from '../Onboarding/Mle/BusinessTab/ImageViewModal';
import { filterSectionCheckerData, formatLabels, headingKeysCheckerView, setDataCheckerRemark } from './mleMakerChecker.utils';
import { MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';
import { IGNORE_UBO_FIELDS } from 'containers/MerchantLegalEntity/constants';

const RiskDetailsView = ({ data, additionalData, auth, handleCheckerRemarksData, isViewMode, editedFields }) => {
  
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const checkerRemarksData = filterSectionCheckerData(additionalData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.risk)?.checkerRemarks[0] || [];

  const flattenObject = (obj, parentKey = '', level = 0) => {
    
    let sectionType = obj?.sectionType ? obj.sectionType : ''; 
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = parentKey ? `${parentKey}.${key}` : key;
        const isObject = typeof value === 'object' && value !== null;
        
        if (key?.toLowerCase() !== 'sectiontype') {
          if (isObject && !Array.isArray(value)) {
            
            acc.push({ label: headingKeysCheckerView(newKey, sectionType), key: `isHeading${newKey}`, isHeading: true, level });
            acc.push(...flattenObject(value, newKey, level + 1));
          } else if (Array.isArray(value)) {
          //  acc.push({ label: newKey.toUpperCase(), key: `isHeading${newKey}`, level });
            value.forEach((item, index) => {
              let addValue = additionalData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE?.ownership_update;
              if (typeof item === 'object' && item !== null) {
                acc.push(...flattenObject(item, `${newKey}[${index + addValue}]`, level + 1));
              } else {
                acc.push({ label: `${newKey}[${index + addValue}]`.toUpperCase(), value: item, level });
              }
            });
          } else {
            acc.push({
              label: formatLabels(newKey),
              value,
              level,
              key: newKey
            });
          }
        }
    
        return acc;
      }, []);
    };

    const handleViewClick = async (docUrl) => {
      const request = { s3Path: docUrl };
      try {
        const response = await POST(API_VIEW_KYC_DOCUMENT, request, {}, true);
        const { data } = response;
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
          setSelectedDocument(data.s3Url);
        } else {
          toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
      } catch (error) {
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
      }
    };


  const selectedCheckerRemarksData = checkerRemarksData.length
  ? checkerRemarksData.map((item) => ({
      label: item.label,
      value: item.value || '',
      status: item.status || null,
      remarks: item.remarks || '',
      key: item.key
    }))
  : flattenObject(data);
  const fetchData = setDataCheckerRemark(selectedCheckerRemarksData, {}, MAKER_CHECKER_EVENT_TYPES_MLE.risk, handleViewClick, isViewMode, editedFields)

  const [riskDetailData, setRiskDetailData] = useState(fetchData);

  useEffect(() => {
    setRiskDetailData(fetchData);
  }, [additionalData]);

  const updateCheckerRemarks = (updatedData) => {
    setRiskDetailData(updatedData);
    
    // let filteredData = updatedData.filter(item => !item.isHeading)
    handleCheckerRemarksData(updatedData);
  };

  const handleAction = (key, actionType) => {
    const updatedData = riskDetailData.map((item) =>
      item.key === key ? { ...item, status: actionType.toUpperCase() } : item
    );
    updateCheckerRemarks(updatedData);
  };

  const handleRemarks = (key, value) => {
    const updatedData = riskDetailData.map((item) =>
      item.key === key ? { ...item, remarks: value } : item
    );
    updateCheckerRemarks(updatedData);
  };

  const fieldsWithViewLink = ['BANK_PROOF', 'URL', 'ADDRESSPROOFURLS'];
  

  const columns = useMemo(
    () => [
      { header: 'Label', accessor: 'clientLabel' },
      { header: 'Value', accessor: 'clientValue' },
      { header: 'Approve', accessor: 'action1' },
      { header: 'Reject', accessor: 'action2' },
      { header: 'Remarks', accessor: 'action3' }
    ],
    []
  );

  // remove id and serial number
  const filteredRiskDetailsData = riskDetailData.filter(data => {
    const label = data?.clientLabel;
    return !(typeof label === 'string' && IGNORE_UBO_FIELDS.includes(label.toLowerCase()));
  })
  
  return (
    <div className="checker-wrapper">
      <Table
        columns={columns}
        data={filteredRiskDetailsData}
        fetchData={() => {}}
        loading={loading}
        userActions={(data, cell) => {
          
          if (data.original?.key?.includes('isHeading')) {
            return cell.column.header === 'Label' ? (
              <strong>{data.values.label}</strong>
            ) : null;
          }

          const field = data.original.key;

          if (cell.column.header === 'Approve') {
            return (
              <input
                checked={data?.original?.status === 'APPROVE'}
                type="radio"
                className="radiogreen"
                name={`${field}-${data.index}`}
                onChange={() => handleAction(field, 'Approve')}
                disabled={isViewMode}
              />
            );
          }
          if (cell.column.header === 'Reject') {
            return (
              <input
                checked={data?.original?.status === 'REJECT'}
                type="radio"
                className="radiored"
                name={`${field}-${data.index}`}
                onChange={() => handleAction(field, 'Reject')}
                disabled={isViewMode}
              />
            );
          }
          if (cell.column.header === 'Remarks') {
            return (
              <input
                value={data?.original?.remarks}
                type="text"
                name={`${field}-remarks-${data.index}`}
                className="eachRemarks"
                onChange={(e) => handleRemarks(field, e.target.value)}
                disabled={isViewMode}
              />
            );
          }
          if (data?.values?.value?.startsWith('/')) {
            return (
              <button
                className="view-link"
                onClick={() => handleViewClick(data.values.value)}
              >
                View
              </button>
            );
          }
          return null;
        }}
      />
      {selectedDocument && (
        <ImageViewModal
          selectedDocument={selectedDocument}
          setSelectedDocument={setSelectedDocument}
        />
      )}
    </div>
  );
};

export default RiskDetailsView;
